import moment from "moment-timezone";

export function validateFuture(rule, value: Date, callback) {
  const errors: string[] = [];
  const today = moment();
  const date = moment(value);

  if (date.isBefore(today)) {
    errors.push("Time is in the past");
  }

  callback(errors);
}
